module.exports = function getResource(label, vars = []) {
    let resources = {
        ends: `Prend fin ${vars[0]}`,
        apply: 'Appliquer dans le panier',
        remove: 'Supprimer',
        applied: 'Appliqué',
        details: 'Détails',
        off: 'de réduction',
        points: 'points',
        pointsForDiscountEventTitle: 'Points pour lʼévénement Réductions',
        gotIt: 'Compris',
        eligible: 'Admissible jusqu’à'
    };
    return resources[label];
};
